<template>
  <div
    class="defenseDig"
  >
    <div class="icon_cont">
      <i @click="closeDialog" class="close_cont el-icon-close"></i>
    </div>
    <div class="table_title">{{ defenseDigProps.title }}清单</div>
    <div class="input_cont flex" >
      <el-input
        placeholder="请输入内容"
        v-model="keyword"
        clearable
        class="input-with-select mr-10px"
        @keydown.enter.native="searchData"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchData"
        ></el-button>
      </el-input>
      <el-select
        v-model="onlineStatus"
        popper-class="cockpit-popper"
        class="input-with-select"
        placeholder="在线状态"
        @change="searchData"
        v-if="defenseDigProps.title === '监控设备'"
      >
        <el-option label="全部" :value="null"></el-option>
        <el-option label="在线" :value="1"></el-option>
        <el-option label="离线" :value="0"></el-option>
      </el-select>
    </div>
    <div class="table_cont" v-loading="listLoading">
      <el-table
        class="unglobal-sty"
        :data="equipmentData"
        style="width: 100%"
        v-if="monitor"
        height="100%"
        ref="multipleTable"
      >
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="name"
          label="设备名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="manufacturerCode"
          label="设备厂商"
          align="center"
          width="100px"
        >
          <template slot-scope="{ row }">
            {{ factureMap[row.manufacturerCode] || row.manufacturerCode }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="deviceType"
          label="设备类型"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ deviceTypeMap[row.deviceType] || row.deviceType }}
          </template>
        </el-table-column>
        <el-table-column label="运行状态" prop="status" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.status === 1" class="successTextColor">在线</div>
            <div v-if="row.status === 2" class="infoText">离线</div>
            <div v-if="row.status === 0" class="infoText">未知</div>
          </template>
        </el-table-column>

        <el-table-column
          property="address"
          label="操作"
          align="center"
          width="100px"
        >
          <template slot-scope="scope">
            <el-button
              class="unglobal-sty table_btn"
              icon="el-icon-view"
              @click.stop="operateIng(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tab_pog">
      <el-pagination
        class="unglobal-sty"
        background
        layout="prev, pager, next"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page.sync="page.pageNo"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <accessRecords
      v-if="accessRecordsDig"
      @closeCurrDig="closeCurrDig"
      :accessRecordsProps="accessRecordsProps"
    />

    <!-- 监控设备弹框 -->
    <div
      class="videoContent"
      v-if="showPlayer"
      @mouseenter="handleMouseenter"
      @mouseleave="handleMouseleave"
    >
      <div class="close_camer" @click="closeCamera">X</div>
      <div class="h5playerCont">
        <H5Player :codeData="codeData" :playerConfig="playerConfig" />
      </div>
    </div>
  </div>
</template>

<script>

import CockpitService from '../service/index'
import AccessRecords from './AccessRecords.vue'
import H5Player from './video/H5Player.vue'

export default {
  props: {
    defenseDigProps: {
      type: Object,
      default: null,
    },
  },
  components: {
    AccessRecords,
    H5Player,
  },
  data() {
    return {
      factureMap: {},
      deviceTypeMap: {},
      listLoading: false,
      commonAreaIds: [],
      areaTreeData: [], // 区域列表
      monitorBoo: false,
      equipmentData: [],
      monitor: true,
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      keyword: '',
      title: '',
      accessRecordsDig: false,
      accessRecordsProps: {
        title: '',
        row: {},
      },
      showPlayer: false,
      cameraCode: [],
      allVehicleBarriers: [], // 全部车辆道闸的数据 - 前端分页
      // 海康视频配置
      playerConfig: {
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: 'ws', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
      },
      codeData: {
        id: 'idhik',
        code: '',
      },
      onlineStatus: null,
    }
  },
  watch: {
    defenseDigProps: {
      deep: true,
      handler(val) {
        this.title = val.title
        this.accessRecordsDig = false
        this.showPlayer = false
        this.page.pageNo = 1
        this.page.total = 0
        this.keyword = ''
        this.onlineStatus = this.defenseDigProps.type
          ? this.defenseDigProps.type === 'online'
            ? 1
            : 0
          : null
        this.getIotDeviceList()
      },
    },
  },
  async created() {
    this.title = this.defenseDigProps.title
    await this.getDataCategoryByCodes()
    this.getIotDeviceList()
  },
  methods: {
    async getDataCategoryByCodes() {
      const [err, res] = await CockpitService.getDataCategoryByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (res) {
        let facturerList = []
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') {
            // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        this.factureMap = facturerList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.deviceTypeMap = deviceTypeList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
      }
    },
    closeCamera() {
      if (this.showPlayer) {
        this.showPlayer = false
      }
    },
    closeDialog() {
      this.$emit('closeDig')
      this.showPlayer = false
    },

    // 搜索 - searchData
    searchData() {
      // 搜索数据
      // 1. 需要 pageNo 置1 在第一页之外的页面搜索 返回第一页搜索数据 才能拿到全部的数据
      // 2. total 置0 请求过慢 搜索数据未拿到, 还保留之前数据的页码, 防止用户在页码没更新之前乱点
      this.page.pageNo = 1
      this.page.total = 0
      this.getIotDeviceList()
    },
    async getIotDeviceList() {
      const [err, res] = await CockpitService.getIotDeviceList({
        Status: this.onlineStatus,
        KeyWord: this.keyword,
        DeviceTypeCode:
          this.defenseDigProps.title === '监控设备'
            ? 'Camera'
            : this.defenseDigProps.title === '门禁设备'
              ? 'AccessControl'
              : 'BarrierGate',
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      })
      if (res) {
        this.equipmentData = res.items
        this.page.total = res.totalCount
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      }
    },
    operateIng(val) {
      if (this.defenseDigProps.title === '监控设备') {
        this.codeData.code = val.code
        this.cameraCode = [val.code]
        this.showPlayer = true
      } else {
        this.accessRecordsProps.title = this.title
        this.accessRecordsProps.row = val
        this.accessRecordsDig = true
      }
    },

    // 当前页码发生改变
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getIotDeviceList()
    },
    closeCurrDig() {
      this.accessRecordsDig = false
    },
    handleMouseenter() {
      const camerEl = document.querySelector('.close_camer')
      camerEl.style.display = 'inline-block'
    },
    handleMouseleave() {
      const camerEl = document.querySelector('.close_camer')
      camerEl.style.display = 'none'
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/css/index.scss";
</style>
<style lang="scss" scoped>
::v-deep .el- .ml-10px {
  margin-left: 10px;
}
::v-deep .imosSdk-video {
  width: 99% !important;
}
.close_camer {
  position: absolute;
  color: #fff;
  right: 2%;
  top: 3.8%;
  z-index: 999;
  cursor: pointer;
  font-size: 12px;
  display: none;
}

.dig_cont_access {
  width: 700px;
  height: 420px;
  position: absolute;
  top: 20%;
  left: 20%;
}
.defenseDig {
  position: absolute;
  width: 700px;
  height: 420px;
  left: 460px;
  top: 92px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 10px;
  background-image: var(--dialogBgImg);

}
.table_title {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}
.icon_cont {
  text-align: right;
  position: relative;
  height: 20px;
  .el-button {
    padding: 5px !important;
    background: #3fbaff4c !important;
    color: #fff;
  }
  .close_cont {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
    background: rgba(63, 186, 255, 0.2980392157) !important;
    color: #fff;
    cursor: pointer;
    border: 1px solid #d9d9d9;
  }
}
.input_cont {
  width: 100%;
  margin-left: 20px;
  display: flex;
  .input-with-select {
    width: 200px;
  }
  .m-l-10 {
    margin-left: 10px;
  }
}
.table_cont {
  height: calc(100% - 135px);
  padding: 10px 20px;
}
.table_btn {
  background: transparent !important;
  border: none !important;
  color: #fff !important;
}
.tab_pog {
  text-align: center !important;
}
.videoContent {
  position: absolute;
  top: 20%;
  left: 10%;
  width: 500px;
  height: 280px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  padding: 0 0%;
  padding-top: 0.5%;
  overflow: hidden;
  margin-left: 0 !important;
  margin-top: 0 !important;
}
.h5playerCont {
  width: 100%;
  height: 98.5%;
}
.h5player {
  width: 100%;
  height: 100%;
  color: #fff;
}
.color-white {
  color: #fff;
}
.text-16px {
  font-size: 16px;
}
.cursor-pointer {
  cursor: pointer;
}
::v-deep .el-input .el-input__inner {
  background: transparent !important;
  color: #fff !important;
  border: 1px solid white !important;
}
::v-deep .el-input-group__append {
  background: transparent !important;
  color: #fff !important;
  .el-button {
    background: transparent !important;
    border-right: none !important;
  }
}
::v-deep .unglobal-sty:hover {
  border-color: #fff !important;
}

::v-deep .el-table {
  th.gutter,
  colgroup.gutter {
    width: 5px !important;
  }
}
::v-deep .el-table__header colgroup col[name="gutter"] {
  display: table-cell !important;
}
::v-deep .el-select .el-tag {
  background-color: #9093998a !important;
  border-color: #9093998a !important;
  color: #fff !important;
  border: none;
}
</style>
